__turbopack_context__.v({
  "box": "CurrentNextSchedule-module-scss-module__FEazAW__box",
  "current": "CurrentNextSchedule-module-scss-module__FEazAW__current",
  "left": "CurrentNextSchedule-module-scss-module__FEazAW__left",
  "notice": "CurrentNextSchedule-module-scss-module__FEazAW__notice",
  "progress": "CurrentNextSchedule-module-scss-module__FEazAW__progress",
  "right": "CurrentNextSchedule-module-scss-module__FEazAW__right",
  "schedule": "CurrentNextSchedule-module-scss-module__FEazAW__schedule",
  "scheduleFooter": "CurrentNextSchedule-module-scss-module__FEazAW__scheduleFooter",
  "scheduleTitle": "CurrentNextSchedule-module-scss-module__FEazAW__scheduleTitle",
  "scrollButton": "CurrentNextSchedule-module-scss-module__FEazAW__scrollButton",
  "time": "CurrentNextSchedule-module-scss-module__FEazAW__time",
  "timeline": "CurrentNextSchedule-module-scss-module__FEazAW__timeline",
  "timelineItem": "CurrentNextSchedule-module-scss-module__FEazAW__timelineItem",
  "title": "CurrentNextSchedule-module-scss-module__FEazAW__title",
});
